<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <v-btn
          block
          min-height="200px"
          color="primary"
          style="font-size: 30px"
          :outlined="createFromScratchOutlined"
          @click="createFromScratchClickedHandler"
        >
          Create From<br>Scratch
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn
          block
          min-height="200px"
          color="primary"
          style="font-size: 30px"
          :outlined="createFromZohoOutlined"
          @click="createFromZohoClickedHandler"
        >
          Create From<br>Zoho
        </v-btn>
      </v-col>
    </v-row>
    <ZRJobOpeningsModal
      ref="ZRJobOpeningsModal"
      @importFromZoho="importFromZohoHandler"
    />
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { CREATE_FROM_SCRATCH, CREATE_FROM_ZOHO } from '@/lib/constants/dealCreationTypes'
import ZRJobOpeningsModal from '@/components/dealsV2/screens/ZRJobOpeningsModal'

export default {
  props: [
    'readonly'
  ],
  components: {
    ZRJobOpeningsModal
  },
  computed: {
    ...mapFields('dealV2', ['deal']),
    createFromScratchOutlined () {
      return !this.deal.dealCreationTypeId ? true : this.deal.dealCreationTypeId !== CREATE_FROM_SCRATCH
    },
    createFromZohoOutlined () {
      return !this.deal.dealCreationTypeId ? true : this.deal.dealCreationTypeId !== CREATE_FROM_ZOHO
    }
  },
  methods: {
    createFromScratchClickedHandler () {
      if (!this.readonly) {
        this.setDealCreationType(CREATE_FROM_SCRATCH)
        this.$emit('complete')
      }
    },
    createFromZohoClickedHandler () {
      if (!this.readonly) {
        this.$refs.ZRJobOpeningsModal.showModal()
      }
    },
    importFromZohoHandler (jobOpening) {
      this.$emit('importFromZoho', jobOpening)
    },
    setDealCreationType (dealCreationType) {
      this.$emit('setDealCreationType', dealCreationType)
    },
    isCreationTypeValid () {
      return !this.deal.dealCreationTypeId ? 'Please select an option to proceed' : true
    }
  }
}
</script>
